import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'App';
import { createStudent, createTeacher } from 'api/playerApi';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

const CreatePlayerModal = ({ playerType, modalShow, setModalShow }) => {
  const [formData, setFormData] = useState({
    name: '',
    price: 20
  });

  const mutation = useMutation({
    mutationFn: playerType == 'S' ? createStudent : createTeacher,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['classroomData'] });
      setModalShow(false);
      toast.success(
        playerType == 'S' ? 'Studente aggiunto.' : 'Professore aggiunto.'
      );
      setFormData({
        name: '',
        price: 20
      });
      setValidated(false);
    },
    onError: err => {
      toast.error(err.response?.data?.message || err.message);
    }
  });
  const [validated, setValidated] = useState(false);

  const handleSubmit = event => {
    const form = event.currentTarget; // get the form element
    event.preventDefault(); // prevent the default form submission
    if (form.checkValidity() === false) {
      // if the form has errors
      event.stopPropagation(); // stop the event propagation
    } else {
      // if the form is valid
      mutation.mutate(formData); // call the mutation
    }
    setValidated(true); // set the validated state to true (to show feedbacks)
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter" className="fs-8">
              Aggiungi {playerType == 'S' ? 'uno studente' : 'un professore'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="p-2 flex-grow-1">
              <Form.Group className="mb-3">
                <Form.Label>Nome</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.name}
                  onChange={handleFieldChange}
                  name="name"
                  maxLength={30}
                  autoComplete="on"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Il nome è obbligatorio
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Prezzo</Form.Label>
                <Form.Control
                  type="number"
                  value={formData.price}
                  onChange={handleFieldChange}
                  min={0}
                  max={500}
                  step={1}
                  name="price"
                  autoComplete="on"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Il prezzo deve essere compreso tra 0 e 500.
                </Form.Control.Feedback>
              </Form.Group>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              disabled={!formData.name || !formData.price || mutation.isLoading}
              type="submit"
            >
              Aggiungi {playerType == 'S' ? 'studente' : 'professore'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

CreatePlayerModal.propTypes = {
  playerType: PropTypes.oneOf(['S', 'T']).isRequired,
  modalShow: PropTypes.bool.isRequired,
  setModalShow: PropTypes.func.isRequired
};

export default CreatePlayerModal;
